import { render, staticRenderFns } from "./DonationContext.vue?vue&type=template&id=0936d762&"
import script from "./DonationContext.vue?vue&type=script&lang=js&"
export * from "./DonationContext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports